export default {
  trackUsers: null,
  user: null,
  users: null,
  totalUsers: null,
  invite: null
};
